import { POPUP_SECTIONS } from "../../../constant/constant";
import {
  COVER_IMAGE_LAYOUT,
  getCoverImageCatalogSizes,
  getCoverImageDisplay,
} from "../../../../shared/product-block-display.js";
import {
  getProductRecommendationImageSlotHeight,
} from "../../../../shared/product-recommendation-popup-schema.js";
import {
  isHorizontalProductShell,
  PRODUCT_SHELL_LAYOUT,
  resolveProductShellLayout,
} from "../../../../shared/product-shell-layout.js";

function getCoverImageSection(productSection) {
  const subsections = productSection?.sections;
  if (!Array.isArray(subsections)) return null;
  return subsections.find((s) => s?.type === POPUP_SECTIONS.COVER_IMAGE) || null;
}

function resolveImageSlotHeight({
  section,
  isMobile,
  isHorizontal,
  layoutProfile,
  mobileCardDensity,
  catalogImageSizes,
}) {
  const coverSection = getCoverImageSection(section);

  if (isHorizontal) {
    if (layoutProfile === "ai-upsell") {
      if (catalogImageSizes?.mainHeight) {
        return Number(catalogImageSizes.mainHeight) || (isMobile ? 120 : 168);
      }
      return isMobile ? 120 : 168;
    }
    return isMobile ? 88 : 104;
  }

  const layout = coverSection
    ? getCoverImageDisplay(coverSection).layout
    : COVER_IMAGE_LAYOUT.SINGLE;

  if (mobileCardDensity === "twin" && isMobile) {
    return getProductRecommendationImageSlotHeight(coverSection, true, {
      imageCount: 1,
      layout,
    });
  }

  return getProductRecommendationImageSlotHeight(coverSection, isMobile, {
    imageCount: 1,
    layout,
  });
}

/**
 * Mirrors ProductRecommendationSlider layout decisions for skeleton rendering.
 */
export function resolveCatalogProductSkeletonPlan({
  section,
  popupData,
  isMobile = false,
  count = 3,
  layoutProfile = "recommendation",
}) {
  const safeCount = Math.max(1, Math.min(Number(count) || 1, 6));
  const shellId =
    layoutProfile === "ai-upsell"
      ? PRODUCT_SHELL_LAYOUT.HORIZONTAL
      : resolveProductShellLayout(section, popupData);
  const isHorizontal = isHorizontalProductShell(shellId);

  const useDesktopGrid =
    layoutProfile !== "ai-upsell" &&
    !isMobile &&
    safeCount > 1 &&
    safeCount <= 3;
  const useMobileTwinGrid =
    layoutProfile !== "ai-upsell" && isMobile && safeCount === 2;
  const useSwiper =
    layoutProfile !== "ai-upsell" &&
    !useDesktopGrid &&
    !useMobileTwinGrid &&
    safeCount > 1;
  const mobileCardDensity =
    useMobileTwinGrid || (isMobile && useSwiper) ? "twin" : "single";
  const displayCount =
    layoutProfile === "ai-upsell" ? 1 : safeCount;

  const coverSection = getCoverImageSection(section);
  const catalogImageSizes = getCoverImageCatalogSizes(coverSection, isMobile);

  const imageSlotHeight = resolveImageSlotHeight({
    section,
    isMobile,
    isHorizontal,
    layoutProfile,
    mobileCardDensity,
    catalogImageSizes,
  });

  let imageColStyle;
  if (isHorizontal && catalogImageSizes?.columnWidth) {
    const width = catalogImageSizes.columnWidth;
    imageColStyle = {
      width,
      minWidth: width,
      maxWidth: width,
      flexShrink: 0,
    };
  } else if (isHorizontal && layoutProfile === "ai-upsell") {
    const width = isMobile ? 108 : 160;
    imageColStyle = {
      width,
      minWidth: width,
      maxWidth: width,
      flexShrink: 0,
    };
  }

  return {
    safeCount: displayCount,
    shellId,
    isHorizontal,
    layoutProfile,
    useDesktopGrid,
    useMobileTwinGrid,
    useSwiper,
    mobileCardDensity,
    imageSlotHeight,
    imageColStyle,
    slidesPerView: isMobile
      ? displayCount >= 2
        ? 2.12
        : 1
      : Math.min(3, displayCount),
  };
}
